import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'
import { EditUserForm } from '@homeviews/users'
import { WindowTitle } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)
const EditCompanyUser: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <WindowTitle title="Edit Company User" />
      <div className={classes.root}>
        <EditUserForm />
      </div>
    </>
  )
}

export default EditCompanyUser
